import type { UserManagementCommunication } from '@dh-software/opus-x-communication';
import { getLoginContext } from './login-context';

/**
 * Baut furnhomes Variante der Usermanagement-Communication. Die Basisklasse kommt als Parameter
 * statt als Import: opus-x-communication soll erst mit dem Modul geladen werden, und ein fester
 * Import zoege sie ins Startpaket.
 */
export function createFurnhomeUserManagementCommunication(BaseCommunication: typeof UserManagementCommunication): typeof UserManagementCommunication {
  return class FurnhomeUserManagementCommunication extends BaseCommunication {
    /**
     * Der Login-Kontext steht in furnhomes Sitzung. opusX' getLoginContact gibt dieselben vier
     * Claims zurueck, verlangt dafuer aber das Modul-Recht der Benutzerverwaltung - die Identitaet
     * des Benutzers haengt damit an einer Modul-Berechtigung, mit der sie nichts zu tun hat.
     *
     * Nicht ueber einen eigenen Aufruf von `/auth/checkSession` geloest: der beruehrt die Sitzung
     * und rotiert die Session-ID, und eine Identitaetsabfrage darf das nicht.
     */
    public override async getLoginContact() {
      return getLoginContext() ?? null;
    }
  };
}
